/* Generated by ./script/iconify.js */
/* eslint-disable */
import React, { PropTypes } from 'react'
import IconBase from './IconBase'
import classnames from 'classnames'

const IconCross = ({ className, ...rest }) => {
  const classes = classnames(
    'icon',
    'icon--cross',
    className,
  )

  return (
    <IconBase className={classes}  viewBox="0 0 14 14"{...rest}><g fill="none" fillRule="evenodd"><path className="path1" fill="#DA291C" fillRule="nonzero" d="M14 1.41L12.59 0 7 5.59 1.41 0 0 1.41 5.59 7 0 12.59 1.41 14 7 8.41 12.59 14 14 12.59 8.41 7z"/><path className="path2" d="M-5-5h24v24H-5z"/></g></IconBase>
  )
}

IconCross.propTypes = {
  className: PropTypes.string,
}

export default IconCross
/* eslint-enable */



// WEBPACK FOOTER //
// ./src/icons/IconCross.js